import React from "react";
import { Link } from "react-router-dom";
import "./BreadCrumb.scss";

const BreadCrumb = (props) => {
  return (
    <div className="breadcrumbHeader">
      <div className="desktop">
        <div className="topBreadcrumb">
          {props.breadCrumbData.map((item, index) => {
            if (item.link) {
              return (
                <Link key={index} className="breadcrumbItem" to={item.link}>
                  {item.title}
                </Link>
              );
            } else {
              return (
                <span key={index} className="breadcrumbItem">
                  {item.title}
                </span>
              );
            }
          })}
        </div>
      </div>
    </div>
  );
};

export default React.memo(BreadCrumb);
